import { Table } from 'antd'
import { FC, useEffect, useState } from 'react'
import { BitazzaText } from '../../../../components'
import { getColor } from '../../../../util/getColor'
import { Badges } from '../../../LeaderBoard/components'
import Style from './TopChallengers.module.scss'
import { useTranslation } from 'react-i18next'
interface Props {
    rank: LeaderBoard[] | []
    notTop3?: boolean
    darkBackground?: boolean
}

type tableType = {
    rank: number
    name: string
    pnl: string
    type: string
    id: number
}

export const TopChallengers: FC<Props> = ({
    rank,
    notTop3,
    darkBackground,
}) => {
    const { t } = useTranslation()
    const columns = [
        {
            title: t('txt_rank'),
            dataIndex: 'rank',
            key: 'rank',
            width: '12%',
            render(text: string) {
                return (
                    <BitazzaText
                        content={text}
                        color="#fff"
                        format="t18"
                        noWrap
                    />
                )
            },
        },
        {
            title: '',
            dataIndex: 'name',
            key: 'name',
            width: '60%',
            render(text: string, record: any) {
                return (
                    <div className={Style.tableName}>
                        <Badges type={record.type} table />
                        <BitazzaText content={text} color="#fff" format="t18" />
                    </div>
                )
            },
        },
        {
            title: '%PNL',
            dataIndex: 'pnl',
            key: 'pnl',
            render(text: number) {
                return (
                    <div className={Style.pnlWrapper}>
                        <BitazzaText
                            content={`${Number(text)?.toFixed(2)}%`}
                            color={getColor(+text)}
                            format="t18"
                            strong
                        />
                    </div>
                )
            },
        },
    ]
    const [data, setData] = useState<tableType[]>([])

    useEffect(() => {
        let sliceNumber = 0
        if (notTop3) {
            sliceNumber = 3
        }
        if (rank && rank.length) {
            setData(
                rank.slice(sliceNumber, 100).map((row) => ({
                    key: row.rank,
                    rank: row.rank,
                    name: row?.additional_user_info?.profileName,
                    pnl: row.score,
                    type: row.tier?.name,
                    id: row.additional_user_info?.userId,
                }))
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rank])

    const mainClass = [Style.container]
    if (darkBackground) {
        mainClass.push(Style.blackContainer)
    }
    return (
        <div className={mainClass.join(' ')}>
            <div className={Style.textWrapper}>
                <BitazzaText
                    content={t('txt_top_challengers')}
                    color="#FFFFFF"
                    format="t16"
                    letterSpacing={2}
                    bold
                />
            </div>

            <Table
                tableLayout="fixed"
                className={Style.table}
                bordered={false}
                rowClassName={Style.rowClassname}
                dataSource={data}
                columns={columns}
                pagination={false}
            />
        </div>
    )
}
